import React, { useCallback, useContext } from 'react';
import { useMutation, useQuery } from '@apollo/client';

import {
  QUERY_GET_MEMBERSHIP,
  MUTATION_UPDATE_MEMBERSHIP,
  QUERY_LIST_MEMBERSHIPS,
} from './queries';
import MembershipForm from './components/MembershipForm';
import routes from 'constants/routes';
import { Col, Row } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import PermissionsAlert from '../../../components/PermissionsAlert/PermissionsAlert';
import { UserContext } from '../../../contexts/UserContext';
import Loader from '../../../components/Loader/Loader';

const MembershipEdit = () => {
  const navigate = useNavigate();
  const { dbUser } = useContext(UserContext);
  const { level_id } = useParams();

  const { data, loading, error } = useQuery(QUERY_GET_MEMBERSHIP, {
    variables: {
      level_id,
    },
  });
  const [updateMembership] = useMutation(MUTATION_UPDATE_MEMBERSHIP);

  const submit = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async ({ capabilities, ...input }: any) => {
      await updateMembership({
        variables: {
          level_id,
          input,
        },
        refetchQueries: [
          {
            query: QUERY_LIST_MEMBERSHIPS,
          },
          {
            query: QUERY_GET_MEMBERSHIP,
            variables: {
              level_id,
            },
          },
        ],
      });
      navigate(routes.MEMBERSHIPS);
    },
    [navigate, updateMembership, level_id],
  );

  if (loading) {
    return <Loader />;
  }

  if (!dbUser?.userPermissions.ManageSettings) {
    return <PermissionsAlert />;
  }

  return (
    <Row gutter={15} style={{ paddingLeft: 10 }}>
      <Col span={24}>
        {!loading && !error ? (
          <MembershipForm
            membership={data.getMembershipLevel}
            handleSubmit={submit}
          />
        ) : error ? (
          'Error:' + error.message
        ) : (
          'loading...'
        )}
      </Col>
    </Row>
  );
};

export default MembershipEdit;
